const JobMapPinSVG = (props: any) =>
  `<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_1845_9789)">
  <circle cx="23" cy="19" r="18" fill="#0F8B8D" fill-opacity="0.25"/>
  <circle cx="23" cy="19" r="12" fill="#0F8B8D"/>
  <path d="M22.1387 25.7764C21.888 25.7764 21.6693 25.7604 21.4824 25.7285C21.291 25.7012 21.127 25.6624 20.9902 25.6123V24.2383C21.1361 24.2747 21.2933 24.3066 21.4619 24.334C21.6305 24.3613 21.8105 24.375 22.002 24.375C22.2526 24.375 22.4805 24.3271 22.6855 24.2314C22.8906 24.1357 23.0524 23.9626 23.1709 23.7119C23.2939 23.4613 23.3555 23.1081 23.3555 22.6523V13H24.9961V22.5977C24.9961 23.3405 24.8776 23.9443 24.6406 24.4092C24.4036 24.8786 24.071 25.2227 23.6426 25.4414C23.2142 25.6647 22.7129 25.7764 22.1387 25.7764Z" fill="white"/>
  </g>
  <defs>
  <filter id="filter0_d_1845_9789" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="4"/>
  <feGaussianBlur stdDeviation="2.5"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1845_9789"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1845_9789" result="shape"/>
  </filter>
  </defs>
  </svg>
`;

export default JobMapPinSVG;